import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styles from './App.module.css';
import ScrollToTop from './Wrappers/ScrollToTop';
import ContentFlow from './Views/v2/ContentFlow';

function App() {
    return (
        <Router>
            <ScrollToTop>
                <Routes>
                    <Route
                        path="*"
                        element={
                            <div className={styles.app}>
                                <ContentFlow />
                            </div>
                        }
                    />
                </Routes>
            </ScrollToTop>
        </Router>
    );
}

export default App;
